"use es6";

/* tslint:disable:no-empty */
export function noop() {}